export const NOTIFICATION_SUMMARY = 'Summary';
export const NOTIFICATION_IMMEDIATE = 'Immediate';

export const generalNotifications = {};

export const supplierNotifications = {
  'd2c-order-received-s': {
    label: 'New Order',
    description: 'Notification a new order is received',
    value: NOTIFICATION_IMMEDIATE,
  },
  'v3-order-overdue': {
    label: 'Order Overdue',
    description:
      'Notification for an order that has not received shipment and is past the recommended Sales Channel SLA',
    value: NOTIFICATION_SUMMARY,
  },
  'cymbio-v3-retailer-accepted-invitation': {
    label: 'Invitation accepted by a Sales Channel',
    description: 'Notification that a new sales channel approved your invitation',
    value: NOTIFICATION_IMMEDIATE,
    options: [{ value: NOTIFICATION_IMMEDIATE, label: 'Immediate' }],
  },
};

export const retailerNotifications = {
  'd2c-order-received': {
    label: 'New Order',
    description: 'Confirmation a new order is received',
    value: NOTIFICATION_IMMEDIATE,
  },
  'v3-retailer-return-notification': {
    label: 'Return',
    description: 'Notification that a returned order was successfully received by the Supplier and can be refunded',
    value: NOTIFICATION_IMMEDIATE,
  },
  'v3-cancellation-notification-retailer': {
    label: 'Cancellation',
    description: 'Notification that an order was cancelled by the Supplier',
    value: NOTIFICATION_IMMEDIATE,
  },
  'd2c-replenishment-shipping-notice': {
    label: 'Order Shipment Notice',
    description: 'Notification that an order was shipped and tracking information is available',
    value: NOTIFICATION_IMMEDIATE,
    options: [{ value: NOTIFICATION_IMMEDIATE, label: 'Immediate' }],
  },
  'commercial-terms-all': {
    label: 'Commercial Terms',
    description: 'Notification that there was an update to your commercial terms',
    value: NOTIFICATION_IMMEDIATE,
    disabled: true,
  },
  RetailerOrderInvoice: {
    label: 'Invoice',
    description: 'If applicable, an invoice notification for each order would be sent. ',
    value: NOTIFICATION_IMMEDIATE,
    disabled: true,
  },
  'v3-partial-fulfillment-notification': {
    label: 'Partial Fulfillment',
    description: 'An Order was shipped, but one or more items were unavailable',
    value: NOTIFICATION_IMMEDIATE,
    options: [{ value: NOTIFICATION_IMMEDIATE, label: 'Immediate' }],
  },
};
